import React, { useEffect, useMemo, useState } from 'react';

import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Modal,
  CardBody,
  Form,
  Input,
  Label,
  Badge,
} from 'reactstrap';

import {
  FaArrowAltCircleRight,
  FaInfoCircle,
  FaPlusCircle,
  FaCopy,
  FaSearch,
  FaEraser,
  FaTimesCircle,
  FaArrowCircleUp,
} from 'react-icons/fa';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from '@material-ui/core';

import 'react-virtualized/styles.css';

import UserSmallHeader from 'components/Headers/UserSmallHeader';
import BotoesProposta from 'components/BotoesProposta';

import toast from 'react-hot-toast';
import OrcamentoStatus from 'models/OrcamentoStatus';
import { useHistory, useParams } from 'react-router-dom';
import Pessoa from 'models/Pessoa';
import AutocompletePessoa from 'components/AutcompletePessoa';
import { Autocomplete } from '@material-ui/lab';

import { OportunidadeCrm } from 'models/OportunidadeCrm';
import Proposta from 'models/Proposta';
import Swal from 'sweetalert2';
import { PropostaVersao } from 'models/PropostaVersao';
import { useQuery } from 'react-query';
import { useAuth } from 'hooks/auth';
import Usuario from 'models/Usuario';
import { Column, Table, AutoSizer } from 'react-virtualized';
import mensagemAtingirMeta from 'utils/mensagemAtingirMeta';
import CampoBuscaFiltrarLista from 'utils/CampoBuscaFiltrarLista';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import api from '../../../services/api';
import { Municipio, PessoaContainer } from './styles';
import { BuscarRegras } from '../Regras/styles';

interface Params {
  codigo?: string;
}

interface OrcamentosVersoes {
  oportunidadeCRM: OportunidadeCrm | null;
  orcamentosVersoes: Orcamentos[];
}

interface DetalhesPessoa {
  razaoSocial: string;
  municipioDescricao?: string;
  ufSigla?: string;
}

interface Orcamentos {
  codigoEmpresa: string;
  codigoOportunidadeDomsge: string;
  createdAt: any;
  descricao: string | null;
  id: number;
  indicPermiteModificar?: boolean | null;
  nome?: string;
  owner_nome?: string;
  usuario_criacao_nome?: string;
  nome_prod: string;
  orcamento_associados?: number[];
  pessoaId: number;
  pessoa_gnf_id: number;
  pivoCentral: string | null;
  proposta_id?: string | null;
  razaoSocial?: string;
  status?: string;
  usuario_id: number;
  usuario_criacao?: number | null;
  versao?: string | null;
  tag?: string | null;
  sub_tag?: string | null;
  usa_tag: boolean;
}

interface OptionPropostaVersao {
  propostaId: number;
  propostaVersaoId: number;
  label: string;
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function renderRow(props: ListChildComponentProps) {
  const { data, index, style } = props;
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: (style.top as number) + 8,
    },
  });
}

const VirtualizedListboxComponent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(function ListboxComponent(props, ref) {
  const { children, ...other } = props;
  const itemData = React.Children.toArray(children);
  const itemCount = itemData.length;
  const itemSize = 40;

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemCount * itemSize;
  };

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <FixedSizeList
          height={getHeight() + 16}
          width="100%"
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={itemSize}
          itemCount={itemCount}
          itemData={itemData}
          overscanCount={5}
        >
          {renderRow}
        </FixedSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

const ConfiguracaoListaGNF: React.FC = () => {
  const { usuario }: { usuario: Usuario } = useAuth();
  const history = useHistory();
  const params = useParams<Params>();
  const codigoOportunidadeDomsgeParam = params?.codigo;

  const [configuracoesMarcadas, setConfiguracoesMarcadas] = useState<number[]>(
    [],
  );
  const [codigoOportunidade, setCodigoOportunidade] = useState('');
  const [codigoGnf, setCodigoGnf] = useState('');
  const [pessoaSelecionada, setPessoaSelecionada] = useState<Pessoa>(
    {} as Pessoa,
  );
  const [detalhesPessoa, setDetalhesPessoa] = useState<DetalhesPessoa | null>();
  const [oportunidadesPesquisadas, setOportunidadesPesquisadas] = useState<
    string[]
  >([]);
  const [oportunidadeCrm, setOportunidadeCrm] =
    useState<OportunidadeCrm | null>();
  const [modalInclusaoEmProposta, setModalInclusaoEmProposta] = useState(false);
  const [propostas, setPropostas] = useState<Proposta[]>([]);
  const [propostaVersoes, setPropostaVersoes] = useState<PropostaVersao[]>([]);
  const [propostaIdFiltrada, setPropostaIdFiltrada] = useState<number>();
  const [propostaVersaoIdFiltrada, setPropostaVersaoIdFiltrada] =
    useState<number>();

  const [propostasGNF, setPropostasGNF] = useState<Proposta[]>([]);
  const [propostasVersoesEmAberto, setPropostasVersoesEmAberto] = useState<
    PropostaVersao[]
  >([]);
  const [propostaSelecionadaId, setPropostaSelecionadaId] =
    useState<string>('');
  const [propostaVersaoSelecionadaId, setPropostaVersaoSelecionadaId] =
    useState<string>('');

  const [mostrarComPropostaBloqueada, setMostrarComPropostaBloqueada] =
    useState(false);
  const [pegarAlternados, setPegarAlternados] = useState(false);
  const [mostrarInativas, setMostrarInativas] = useState(false);
  const [configuracaoIdPesquisar, setConfiguracaoIdPesquisar] =
    useState<string>('');

  const [acessoLimitado, setAcessoLimitado] = useState(true);
  const [resultadoFiltrado, setResultadoFiltrado] = useState(
    [] as Orcamentos[],
  );
  const [exibeCampoBusca, setExibeCampoBusca] = useState(false);
  const [habilitarBotaoNovo, setHabilitarBotaoNovo] = useState(false);

  const [orcamentos, setOrcamentos] = useState<Orcamentos[]>([]);
  const [triggerSearch, setTriggerSearch] = useState(false);

  const opcoesPropostaVersao = useMemo<OptionPropostaVersao[]>(() => {
    // Se já existem orçamentos/configurações na tela, filtra apenas as propostas e versões presentes nelas
    if (orcamentos && orcamentos.length > 0) {
      const keys = new Set<string>();
      const optionsFromOrcamentos: OptionPropostaVersao[] = [];

      orcamentos.forEach((item: any) => {
        const propConfigs =
          item?.orcamento?.PropostaConfiguracao ||
          item?.PropostaConfiguracao ||
          [];
        propConfigs.forEach((pc: any) => {
          if (pc?.propostaVersao) {
            const pId = pc.propostaVersao.propostaId;
            const pVersaoId = pc.propostaVersao.id;
            const pVersaoNum = pc.propostaVersao.versao;
            const key = `${pId}-${pVersaoId}`;
            if (!keys.has(key)) {
              keys.add(key);
              optionsFromOrcamentos.push({
                propostaId: pId,
                propostaVersaoId: pVersaoId,
                label: `Proposta ${pId} - Versão ${pVersaoNum}`,
              });
            }
          }
        });
      });

      if (optionsFromOrcamentos.length > 0) {
        return optionsFromOrcamentos.sort(
          (a, b) => a.propostaId - b.propostaId,
        );
      }
    }

    const options: OptionPropostaVersao[] = [];
    (propostas || []).forEach(proposta => {
      if (proposta.PropostaVersao && proposta.PropostaVersao.length > 0) {
        proposta.PropostaVersao.forEach(versao => {
          const propConfigs = (versao as any).PropostaConfiguracao;
          if (!propConfigs || propConfigs.length > 0) {
            options.push({
              propostaId: proposta.id,
              propostaVersaoId: versao.id,
              label: `Proposta ${proposta.id} - Versão ${versao.versao}`,
            });
          }
        });
      }
    });
    return options;
  }, [propostas, orcamentos]);

  const opcaoPropostaVersaoSelecionada = useMemo(() => {
    if (!propostaIdFiltrada || !propostaVersaoIdFiltrada) return null;
    return (
      opcoesPropostaVersao.find(
        opt =>
          opt.propostaId === propostaIdFiltrada &&
          opt.propostaVersaoId === propostaVersaoIdFiltrada,
      ) || null
    );
  }, [opcoesPropostaVersao, propostaIdFiltrada, propostaVersaoIdFiltrada]);

  const { data: dataPropostas } = useQuery('lista-propostas', async () => {
    async function getPropostas(): Promise<Proposta[]> {
      const response = await api.get('/proposta/lista-simplificada', {
        params: {
          gnf: '',
        },
      });
      return response.data;
    }

    const data = await getPropostas();
    return data;
  });

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 19,
      },
    });
    setAcessoLimitado(response.data);
  }

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    getAcessoLimitadoPrograma();
  }, []);

  useEffect(() => {
    if (dataPropostas) {
      setPropostas(dataPropostas);
    }
  }, [dataPropostas]);

  useEffect(() => {
    const propostaVersoesFiltradas = propostas.find(
      proposta => proposta.id === propostaIdFiltrada,
    )?.PropostaVersao;

    if (propostaVersoesFiltradas) {
      setPropostaVersoes(propostaVersoesFiltradas);
    }
  }, [propostaIdFiltrada]);

  function setOportunidadesPesquisadasArray(oportunidades?: string | null) {
    if (!oportunidades) return;

    const oportunidadesArray = oportunidades?.split(',') ?? [];

    setOportunidadesPesquisadas(oportunidadesArray);
  }

  function getOportunidadesPesquisadas() {
    const oportunidades = localStorage.getItem('oportunidadesPesquisadas');

    setOportunidadesPesquisadasArray(oportunidades);

    return oportunidades;
  }

  function storeOportunidadesPesquisadas() {
    if (!codigoOportunidade) return;

    const oportunidades = getOportunidadesPesquisadas();

    const novoOportunidadesPesquisadas = oportunidades
      ? `${codigoOportunidade},${oportunidades}`
      : codigoOportunidade;

    const jaExisteOportunidade = oportunidades
      ?.split(',')
      .find(oportunidade => oportunidade === codigoOportunidade);

    if (jaExisteOportunidade) return;

    setOportunidadesPesquisadasArray(novoOportunidadesPesquisadas);

    localStorage.setItem(
      'oportunidadesPesquisadas',
      novoOportunidadesPesquisadas,
    );
  }

  async function filtraPropostasGNF(gnfParam?: string) {
    const gnf = gnfParam ?? codigoOportunidade;
    const propostasFilteredGNF = propostas.filter(
      proposta => proposta.codigoOportunidadeDomsge === gnf || !gnf,
    );
    setPropostasGNF(propostasFilteredGNF);
  }

  async function handleBuscaOportunidades(
    codigoOportunidadeParam?: string,
    mostrarInativasParam?: boolean,
  ) {
    setOrcamentos([]);
    setExibeCampoBusca(true);

    const inativasValue =
      mostrarInativasParam !== undefined
        ? mostrarInativasParam
        : mostrarInativas;

    const contexto = {
      gnf: codigoOportunidadeParam ?? codigoOportunidade,
      propostaId: propostaIdFiltrada,
      propostaVersaoId: propostaVersaoIdFiltrada,
      codigoCliente: pessoaSelecionada,
      configuracaoId: configuracaoIdPesquisar,
      mostrarBloquedados: mostrarComPropostaBloqueada,
      mostrarAlternados: pegarAlternados,
      mostrarInativas: inativasValue,
    };

    localStorage.setItem('lista_configuracoes', JSON.stringify(contexto));

    const toastBusca = toast.loading('Buscando...');
    try {
      const response = await api.get('/orcamento/versao-codigo-domsge', {
        params: {
          codigoOportunidadeDomsgeAgrupador:
            codigoOportunidadeParam ?? codigoOportunidade,
          codigoCliente: pessoaSelecionada.codigoDomsge,
          propostaId: propostaIdFiltrada,
          propostaVersaoId: propostaVersaoIdFiltrada,
          somenteConfiguracoesEditaveis: !mostrarComPropostaBloqueada,
          configuracaoIdPesquisar,
          pegarAlternados,
          mostrarInativas: inativasValue,
        },
      });

      setOrcamentos(response.data.orcamentosVersoes);

      storeOportunidadesPesquisadas();
      const orcametosVersoesData = response.data as OrcamentosVersoes;
      setOportunidadeCrm(orcametosVersoesData.oportunidadeCRM);
      const oportunidade = orcametosVersoesData.oportunidadeCRM;
      const { RAZAO_SOCIAL, CIDADE, ESTADO } = oportunidade || {};

      let gnfFinal = codigoOportunidadeParam ?? codigoOportunidade;

      if (
        !gnfFinal &&
        configuracaoIdPesquisar &&
        configuracaoIdPesquisar.trim() !== ''
      ) {
        const gnf =
          oportunidade?.NUMERO_NEGOCIO ||
          orcametosVersoesData.orcamentosVersoes?.[0]?.codigoOportunidadeDomsge;
        if (gnf) {
          gnfFinal = String(gnf);
          setCodigoOportunidade(gnfFinal);
        }
      }

      const novoDetalhesPessoa = {
        razaoSocial:
          RAZAO_SOCIAL ||
          (configuracaoIdPesquisar?.trim() || gnfFinal
            ? orcametosVersoesData.orcamentosVersoes?.[0]?.razaoSocial
            : '') ||
          '',
        municipioDescricao: CIDADE || '',
        ufSigla: ESTADO || '',
      };

      if (oportunidade && oportunidade.NUMERO_NEGOCIO) {
        setHabilitarBotaoNovo(true);
      } else {
        setHabilitarBotaoNovo(false);
      }

      setDetalhesPessoa(novoDetalhesPessoa);
      if (!orcametosVersoesData.orcamentosVersoes.length) {
        toast.error('Nenhuma configuração encontrada!', {
          id: toastBusca,
        });
        return;
      }

      const orcamentoIds = orcametosVersoesData.orcamentosVersoes.map(
        orcamentoVersao => orcamentoVersao.id,
      );

      filtraPropostasGNF(gnfFinal);
      toast.remove(toastBusca);
    } catch {
      toast.remove(toastBusca);
    }
  }

  function limparContexto() {
    localStorage.removeItem('lista_configuracoes');
    setCodigoOportunidade('');
    setPropostaIdFiltrada(undefined);
    setPessoaSelecionada({} as Pessoa);
    setConfiguracaoIdPesquisar('');
    setPropostaVersaoIdFiltrada(undefined);
    setMostrarComPropostaBloqueada(false);
    setPegarAlternados(false);
    setMostrarInativas(false);
    setTriggerSearch(true);
  }

  async function carregaOrcamentoByCodigoDomsge() {
    setCodigoOportunidade(codigoOportunidadeDomsgeParam || '');
    handleBuscaOportunidades(codigoOportunidadeDomsgeParam);
  }

  useEffect(() => {
    if (triggerSearch) {
      handleBuscaOportunidades();
      setTriggerSearch(false);
    }
  }, [triggerSearch]);

  useEffect(() => {
    if (codigoOportunidadeDomsgeParam) {
      carregaOrcamentoByCodigoDomsge();
    }
  }, [codigoOportunidadeDomsgeParam]);

  useEffect(() => {
    const contextoSalvo = localStorage.getItem('lista_configuracoes');

    if (contextoSalvo) {
      const contexto = JSON.parse(contextoSalvo);

      setCodigoOportunidade(contexto.gnf ?? '');
      setPropostaIdFiltrada(contexto.propostaId ?? '');
      setPessoaSelecionada(contexto.codigoCliente ?? '');
      setConfiguracaoIdPesquisar(contexto.configuracaoId ?? '');
      setPropostaVersaoIdFiltrada(contexto.propostaVersaoId ?? '');
      setMostrarComPropostaBloqueada(contexto.mostrarBloquedados ?? false);
      setPegarAlternados(contexto.mostrarAlternados ?? false);
      setMostrarInativas(contexto.mostrarInativas ?? false);

      setTriggerSearch(true);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      getOportunidadesPesquisadas();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    setPropostasVersoesEmAberto([]);
    const proposta = propostas.find(
      propost => propost.id === Number(propostaSelecionadaId),
    );
    if (proposta) {
      setPropostasVersoesEmAberto(
        proposta?.PropostaVersao.filter(
          propostaVersao => propostaVersao.status.id === 1, // status id 1: Gerada
        ),
      );
    }
  }, [propostaSelecionadaId, propostas]);

  function handleKeyPress(event: React.KeyboardEvent) {
    if (event.key === 'Enter') {
      handleBuscaOportunidades();
    }
  }

  function handleNavigateNovoOrcamento() {
    let continuar = true;
    if (oportunidadeCrm) {
      const oportunidadeBloqueada =
        oportunidadeCrm.OPORTUNIDADE_BLOQUEADA === 'S';
      const statusAtivo = oportunidadeCrm.STATUS === 'A';
      const descricaoStatus =
        // eslint-disable-next-line no-nested-ternary
        oportunidadeCrm.STATUS === 'G'
          ? 'Ganha'
          : oportunidadeCrm.STATUS === 'P'
          ? 'Perdida'
          : 'Cancelada';

      if (oportunidadeBloqueada) {
        continuar = false;
        Swal.fire({
          icon: 'error',
          text: `GNF está bloqueado no CRM. Novas configurações estão bloqueadas`,
          allowOutsideClick: false,
          showConfirmButton: true,
        });
      }

      if (!statusAtivo) {
        continuar = false;
        Swal.fire({
          icon: 'error',
          text: `GNF está com o status '${descricaoStatus}' no CRM. Novas configurações estão bloqueadas`,
          allowOutsideClick: false,
          showConfirmButton: true,
        });
      }
    }

    if (continuar) {
      history.push({
        pathname: `/admin/cadastro-orcamento-novo`,
        state: {
          oportunidadeCrm,
          codigoOportunidade:
            codigoOportunidade ||
            (oportunidadeCrm?.NUMERO_NEGOCIO
              ? String(oportunidadeCrm.NUMERO_NEGOCIO)
              : ''),
        },
      });
    }
  }

  function onChangeAutocompleteCodigoOportunidade(
    pCodigoOportunidade: string | null,
  ) {
    setHabilitarBotaoNovo(false);
    setCodigoOportunidade(pCodigoOportunidade ?? '');
    setPessoaSelecionada({} as Pessoa);
    setDetalhesPessoa({} as Pessoa);
  }

  function handleChangeSelecao(
    event: React.ChangeEvent<HTMLInputElement>,
    orcamentoId: number,
  ) {
    setConfiguracoesMarcadas(prevConfiguracoes => {
      if (event.target.checked) {
        return [...prevConfiguracoes, orcamentoId];
      }
      return prevConfiguracoes.filter(configId => configId !== orcamentoId);
    });
  }

  async function handleAskNovaProposta() {
    async function geraNovaProposta(): Promise<Proposta> {
      Swal.fire({
        icon: 'info',
        text: 'Gerando proposta...',
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      const response = await api.post('/proposta', {
        codigoGNF: codigoOportunidade !== '' ? codigoOportunidade : codigoGnf,
        codigoCliente: pessoaSelecionada.id,
        configuracoes: configuracoesMarcadas,
      });
      Swal.close();
      return response.data;
    }

    Swal.fire({
      title: `Gerar proposta para as configurações ${configuracoesMarcadas.join(
        ', ',
      )}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        const proposta = await geraNovaProposta();

        history.push({
          pathname: '/admin/proposta',
          state: { proposta, propostaVersao: proposta.PropostaVersao[0] },
        });
      }
    });
  }

  async function handleInclusaoEmProposta() {
    async function incluiEmProposta(): Promise<void> {
      await mensagemAtingirMeta(
        `Foi adicionada uma configuração na proposta`,
        Number(propostaVersaoSelecionadaId),
      );
      Swal.fire({
        icon: 'info',
        text: `Incluindo configuração(ões) na proposta ${propostaSelecionadaId}...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      await api.post('/proposta/configuracao', {
        propostaVersaoId: Number(propostaVersaoSelecionadaId),
        configuracoes: configuracoesMarcadas,
        gnf: Number(codigoOportunidade),
        propostaId: Number(propostaSelecionadaId),
      });
      Swal.close();
    }

    async function buscaProposta() {
      const response = await api.get(`/proposta/${propostaSelecionadaId}`);
      return response.data;
    }

    await incluiEmProposta();
    setConfiguracoesMarcadas([]);
    setModalInclusaoEmProposta(false);

    const proposta = await buscaProposta();
    const propostaVersaoSelecionada = propostasVersoesEmAberto.find(
      propostaVersao =>
        propostaVersao.id === Number(propostaVersaoSelecionadaId),
    );

    Swal.fire({
      title: `Navegar para proposta?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, navegar`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Fechar`,
    }).then(async result => {
      if (result.isConfirmed) {
        history.push({
          pathname: '/admin/proposta',
          state: { proposta, propostaVersao: propostaVersaoSelecionada },
        });
      }
    });
  }

  async function duplicarRegistro(codigo: number) {
    async function duplicar() {
      const retorno = await api.post(`/orcamento//${codigo}/duplicar`, {});

      history.push({
        pathname: `/admin/cadastro-orcamento-novo`,
        state: { orcamento: retorno.data },
      });
    }

    Swal.fire({
      title: `Deseja duplicar as informações da configuração #${codigo} em um novo registro?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, duplicar`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        toast.promise(duplicar(), {
          loading: 'Aguarde...',
          success: <b>Tudo certo!</b>,
          error: <b>Algo de errado aconteceu.</b>,
        });
      }
    });
  }

  async function handleDesativaRegistro(codigo: number) {
    async function desativar() {
      await api.put(`/orcamento/${codigo}/status`, { status: 'I' });
      await handleBuscaOportunidades();
    }

    Swal.fire({
      title: `Deseja desativar a configuração #${codigo}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, desativar`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        toast.promise(desativar(), {
          loading: 'Aguarde...',
          success: <b>Configuração desativada com sucesso!</b>,
          error: (err: any) => (
            <b>
              {err?.response?.data?.message ||
                'Erro ao desativar configuração.'}
            </b>
          ),
        });
      }
    });
  }

  async function handleAtivaRegistro(codigo: number) {
    async function ativar() {
      await api.put(`/orcamento/${codigo}/status`, { status: 'A' });
      await handleBuscaOportunidades();
    }

    Swal.fire({
      title: `Deseja reativar a configuração #${codigo}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: `Sim, reativar`,
      confirmButtonColor: '#2dce89',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        toast.promise(ativar(), {
          loading: 'Aguarde...',
          success: <b>Configuração reativada com sucesso!</b>,
          error: (err: any) => (
            <b>
              {err?.response?.data?.message || 'Erro ao reativar configuração.'}
            </b>
          ),
        });
      }
    });
  }

  function formatarData(isoString: string) {
    const data = new Date(isoString);
    const dia = String(data.getUTCDate()).padStart(2, '0');
    const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
    const ano = data.getUTCFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  async function navegarConfiguracao(orcamentoVersaoId: number) {
    toast.loading('Navegando para a configuração.');

    const orcamentoVersao = await api.get(`/orcamento/${orcamentoVersaoId}`);

    history.push({
      pathname: `/admin/cadastro-orcamento-novo`,
      state: { orcamento: orcamentoVersao.data },
    });

    toast.dismiss();
  }

  function criarListaConfiguracoes(orcamentoList: Orcamentos[]) {
    return (
      <div
        id="list-container"
        style={{
          width: '100%',
          height: '100vh',
          overflow: 'hidden',
          textAlign: 'center',
        }}
      >
        <AutoSizer>
          {({ width, height }) => (
            <Table
              key={orcamentoList.length}
              width={width}
              height={height}
              headerHeight={40}
              rowHeight={70}
              rowCount={orcamentoList.length}
              rowGetter={({ index }) => orcamentoList[index]}
              rowStyle={({ index }) => {
                if (index < 0) {
                  return {
                    borderBottom: '1px solid #ccc',
                    fontSize: '0.9rem',
                  };
                }
                const row = orcamentoList[index];
                const isInativo = row?.status === 'I';
                return {
                  borderBottom: '1px solid #ccc',
                  fontSize: '0.9rem',
                  opacity: isInativo ? 0.75 : 1,
                  backgroundColor: isInativo ? '#f8f9fa' : '#ffffff',
                };
              }}
            >
              <Column
                key="checkbox"
                label=""
                dataKey="checkbox"
                width={60}
                cellRenderer={({ rowData }) => {
                  const isInativo = rowData.status === 'I';
                  return (
                    <Checkbox
                      key={rowData.id}
                      className=""
                      color="primary"
                      size="small"
                      disabled={isInativo}
                      hidden={!(rowData.proposta_id === null) || isInativo}
                      checked={configuracoesMarcadas.includes(
                        Number(rowData.id),
                      )}
                      onChange={event => {
                        if (!isInativo) {
                          handleChangeSelecao(event, rowData.id);
                          setCodigoGnf(rowData.codigoOportunidadeDomsge ?? '');
                        }
                      }}
                    />
                  );
                }}
              />

              <Column
                label="#"
                dataKey="id"
                width={150}
                cellRenderer={({ rowData }) => {
                  return (
                    <div className="flex items-left">
                      <div>
                        <Tooltip title="Navegar para a configuração">
                          <span>
                            <Button
                              className="btn-icon btn-2"
                              type="button"
                              onClick={() => navegarConfiguracao(rowData.id)}
                              size="sm"
                            >
                              {rowData.id}
                            </Button>
                          </span>
                        </Tooltip>
                        {rowData.orcamento_associados &&
                        rowData.orcamento_associados.length > 0 ? (
                          <span
                            title={`Configuração Alternada: ${rowData.orcamento_associados.join(
                              ', ',
                            )}`}
                            style={{
                              paddingLeft: '0px',
                              marginLeft: '0px',
                              color: 'blue',
                            }}
                          >
                            ℹ️
                          </span>
                        ) : (
                          <span
                            style={{
                              paddingLeft: '10px',
                              marginLeft: '0px',
                              color: 'blue',
                            }}
                          >
                            {' '}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                }}
              />

              <Column
                label="GNF"
                dataKey="codigoOportunidadeDomsge"
                width={100}
                cellRenderer={({ rowData }) => (
                  <div>
                    <strong>{rowData.codigoOportunidadeDomsge}</strong>
                    <br />
                    <small>{rowData.codigoEmpresa}</small>
                  </div>
                )}
              />

              <Column
                label="CLIENTE"
                dataKey="pivoCentral"
                width={350}
                cellRenderer={({ rowData }) => (
                  <div>
                    <strong>{rowData.razaoSocial}</strong>
                    <br />
                    <small>
                      {rowData.pivoCentral ??
                        (rowData.usa_tag ? rowData.tag : '')}
                    </small>
                    {rowData.pivoCentral === null &&
                      rowData.usa_tag &&
                      rowData.sub_tag && (
                        <>
                          <br />
                          <small>({rowData.sub_tag})</small>
                        </>
                      )}
                  </div>
                )}
              />

              <Column label="PRODUTO" dataKey="nome_prod" width={150} />

              <Column
                label="PROPOSTA"
                dataKey="proposta_id"
                width={300}
                cellRenderer={({ rowData }) => {
                  const isPropostaBloqueada =
                    rowData.indicPermiteModificar ?? false;
                  return (
                    <div
                      style={{
                        fontSize: '1rem',
                      }}
                    >
                      {rowData.proposta_id ? (
                        <Badge
                          style={{
                            background: `${
                              !isPropostaBloqueada ? '#f8ac59' : '#1a7bb9'
                            }`,
                            color: '#ffffff',
                          }}
                          className="p-2"
                        >
                          {rowData.proposta_id} | Versão {rowData.versao}:{' '}
                          {rowData.descricao}
                        </Badge>
                      ) : (
                        ''
                      )}
                    </div>
                  );
                }}
              />
              <Column
                label="OWNER"
                dataKey="owner_nome"
                width={200}
                cellRenderer={({ rowData }) => (
                  <div
                    style={{
                      fontSize: '1rem',
                    }}
                  >
                    <Badge
                      style={{
                        backgroundColor:
                          rowData.status === 'I' ? '#adb5bd' : '#57ad75',
                        color: '#fff',
                      }}
                      className="p-2"
                    >
                      {rowData.owner_nome || rowData.nome || ''}
                    </Badge>
                  </div>
                )}
              />
              <Column
                label="USUÁRIO"
                dataKey="usuario_criacao_nome"
                width={200}
                cellRenderer={({ rowData }) => {
                  const nomeCriador =
                    rowData.usuario_criacao_nome || rowData.nome || '';
                  return (
                    <div
                      style={{
                        fontSize: '1rem',
                      }}
                    >
                      <Badge
                        style={{
                          backgroundColor:
                            rowData.status === 'I' ? '#adb5bd' : '#57ad75',
                          color: '#fff',
                        }}
                        className="p-2"
                      >
                        {nomeCriador}
                      </Badge>
                    </div>
                  );
                }}
              />
              <Column
                label="DATA"
                dataKey="createdAt"
                width={150}
                cellRenderer={({ cellData }) => <>{formatarData(cellData)}</>}
              />
              <Column
                label=""
                dataKey=""
                width={100}
                cellRenderer={({ rowData }) => {
                  const isInativo = rowData.status === 'I';
                  const temProposta = Boolean(rowData.proposta_id);
                  const isAlternado = Boolean(
                    rowData.orcamento_associados &&
                      rowData.orcamento_associados.length > 0,
                  );

                  let tooltipDesativa = 'Desativar configuração';
                  let podeDesativar = true;
                  if (temProposta) {
                    podeDesativar = false;
                    tooltipDesativa =
                      'Não é possível desativar uma configuração associada a uma proposta.';
                  } else if (isAlternado) {
                    podeDesativar = false;
                    tooltipDesativa =
                      'Não é possível desativar uma configuração alternada.';
                  }

                  return (
                    <div className="d-flex align-items-center justify-content-center">
                      <Tooltip
                        title={
                          isInativo
                            ? 'Não é permitido duplicar configuração inativa'
                            : 'Duplicar registro em uma nova configuração'
                        }
                      >
                        <span>
                          <Button
                            className="btn-icon btn-2 mr-1"
                            type="button"
                            disabled={isInativo}
                            onClick={() =>
                              !isInativo && duplicarRegistro(rowData.id)
                            }
                            size="sm"
                          >
                            <FaCopy />
                          </Button>
                        </span>
                      </Tooltip>

                      {isInativo ? (
                        <Tooltip title="Reativar configuração">
                          <span>
                            <Button
                              className="btn-icon btn-2"
                              color="default"
                              type="button"
                              onClick={() => handleAtivaRegistro(rowData.id)}
                              size="sm"
                            >
                              <FaArrowCircleUp />
                            </Button>
                          </span>
                        </Tooltip>
                      ) : (
                        <Tooltip title={tooltipDesativa}>
                          <span>
                            <Button
                              className="btn-icon btn-2"
                              color="danger"
                              type="button"
                              disabled={!podeDesativar}
                              onClick={() =>
                                podeDesativar &&
                                handleDesativaRegistro(rowData.id)
                              }
                              size="sm"
                            >
                              <FaTimesCircle />
                            </Button>
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  );
                }}
              />
            </Table>
          )}
        </AutoSizer>
      </div>
    );
  }

  const listaConfiguracoes = useMemo(() => {
    return criarListaConfiguracoes(
      resultadoFiltrado.length > 0 ? resultadoFiltrado : orcamentos,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    resultadoFiltrado,
    orcamentos,
    configuracoesMarcadas,
    criarListaConfiguracoes,
  ]);

  return (
    <>
      <UserSmallHeader />

      <Modal
        className="modal-dialog-centered"
        size="sm"
        isOpen={modalInclusaoEmProposta}
        toggle={() => setModalInclusaoEmProposta(false)}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary border-0 mb-0">
            <CardHeader className="bg-transparent">
              <div className="text-muted text-center">
                <strong>
                  Incluir em proposta existente - GNF {codigoOportunidade}
                </strong>
              </div>
              <div className="btn-wrapper text-center" />
            </CardHeader>
            <CardBody className="px-lg-5 ">
              <Form role="form">
                <Input
                  type="select"
                  value={propostaSelecionadaId}
                  onChange={event =>
                    setPropostaSelecionadaId(event.target.value)
                  }
                >
                  <option value="">Selecione a proposta...</option>
                  {propostas
                    .filter(
                      proposta =>
                        proposta.codigoOportunidadeDomsge ===
                        codigoOportunidade,
                    )
                    .map(proposta => (
                      <option key={proposta.id} value={proposta.id}>
                        Proposta {proposta.id}
                      </option>
                    ))}
                </Input>
                {propostaSelecionadaId && (
                  <div className="mt-3">
                    <Input
                      type="select"
                      value={propostaVersaoSelecionadaId}
                      onChange={event =>
                        setPropostaVersaoSelecionadaId(event.target.value)
                      }
                    >
                      <option value="">Selecione a versão...</option>
                      {propostasVersoesEmAberto?.map(propostaVersao => (
                        <option
                          key={propostaVersao.id}
                          value={propostaVersao.id}
                        >
                          Versão {propostaVersao.versao}
                        </option>
                      ))}
                    </Input>
                  </div>
                )}
                <div className="text-center">
                  <Button
                    className="my-4 w-100"
                    color="primary"
                    type="button"
                    onClick={handleInclusaoEmProposta}
                  >
                    Incluir
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </div>
      </Modal>

      <Container className="mt-2" fluid>
        <Row>
          <Col xs="12" md="12">
            <Card className="shadow p-2">
              <Row onKeyPress={handleKeyPress}>
                <Col sm="2">
                  <Autocomplete
                    options={oportunidadesPesquisadas}
                    value={codigoOportunidade}
                    clearOnBlur={false}
                    onInputChange={(_, novoCodigoOportunidade) =>
                      onChangeAutocompleteCodigoOportunidade(
                        novoCodigoOportunidade,
                      )
                    }
                    onChange={(_, novoCodigoOportunidade) =>
                      onChangeAutocompleteCodigoOportunidade(
                        novoCodigoOportunidade,
                      )
                    }
                    renderInput={autcompleteParams => (
                      <TextField
                        {...autcompleteParams}
                        size="small"
                        variant="outlined"
                        label="GNF Base"
                        type="text"
                      />
                    )}
                  />
                </Col>

                <Col sm="3">
                  <Autocomplete
                    options={opcoesPropostaVersao}
                    ListboxComponent={VirtualizedListboxComponent}
                    getOptionLabel={option =>
                      typeof option === 'string' ? option : option.label || ''
                    }
                    getOptionSelected={(option, value) =>
                      option.propostaId === value.propostaId &&
                      option.propostaVersaoId === value.propostaVersaoId
                    }
                    filterOptions={(options, state) => {
                      const query = state.inputValue.trim().toLowerCase();
                      if (!query) {
                        return options;
                      }
                      return options.filter(opt =>
                        opt.label.toLowerCase().includes(query),
                      );
                    }}
                    value={opcaoPropostaVersaoSelecionada}
                    onChange={(_, newValue: OptionPropostaVersao | null) => {
                      if (newValue) {
                        setPropostaIdFiltrada(newValue.propostaId);
                        setPropostaVersaoIdFiltrada(newValue.propostaVersaoId);
                      } else {
                        setPropostaIdFiltrada(undefined);
                        setPropostaVersaoIdFiltrada(undefined);
                      }
                    }}
                    renderInput={autcompleteParams => (
                      <TextField
                        {...autcompleteParams}
                        size="small"
                        variant="outlined"
                        label="Proposta / Versão"
                      />
                    )}
                  />
                </Col>

                <Col
                  sm="auto"
                  style={{
                    width: '18%',
                  }}
                >
                  <BuscarRegras
                    style={{ width: '100%' }}
                    className=""
                    id="outlined-basic"
                    label="Configuração"
                    variant="outlined"
                    size="small"
                    type="text"
                    value={configuracaoIdPesquisar}
                    onChange={event => {
                      setConfiguracaoIdPesquisar(event.target.value);

                      if (event.target.value === '') {
                        setPegarAlternados(false);
                      }
                    }}
                  />
                </Col>

                <Col
                  sm="auto"
                  style={{
                    width: '22%',
                  }}
                >
                  <AutocompletePessoa
                    onChange={(_, newValue) => {
                      setCodigoOportunidade('');
                      setPessoaSelecionada(newValue ?? ({} as Pessoa));
                    }}
                    limitarPorConfiguracao
                    pessoaSelecionada={pessoaSelecionada}
                  />
                </Col>

                <Col sm="2" className="d-flex justify-content-end">
                  <Button
                    className="btn-icon btn-2 mr-2"
                    color="primary"
                    type="button"
                    onClick={() => handleBuscaOportunidades()}
                  >
                    <FaSearch />
                  </Button>

                  <Button
                    className="btn-icon btn-2"
                    color="danger"
                    type="button"
                    onClick={limparContexto}
                  >
                    <FaEraser />
                  </Button>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col sm="3">
                  <FormControlLabel
                    className="ml-1"
                    style={{
                      alignItems: 'center',
                      marginBottom: 0,
                    }}
                    control={
                      <Checkbox
                        className="p-0"
                        color="primary"
                        size="small"
                        checked={mostrarComPropostaBloqueada}
                        onChange={event =>
                          setMostrarComPropostaBloqueada(event.target.checked)
                        }
                      />
                    }
                    label={
                      <span style={{ whiteSpace: 'nowrap' }}>
                        Mostrar com proposta bloqueada
                      </span>
                    }
                  />
                </Col>

                <Col sm="3">
                  <FormControlLabel
                    className="ml-1"
                    style={{
                      alignItems: 'center',
                      marginBottom: 0,
                    }}
                    // style={{ marginLeft: '-10rem !important' }}
                    control={
                      <Checkbox
                        className="p-0"
                        color="primary"
                        size="small"
                        checked={
                          pegarAlternados &&
                          configuracaoIdPesquisar !== undefined &&
                          configuracaoIdPesquisar !== ''
                        }
                        disabled={!configuracaoIdPesquisar}
                        onChange={event =>
                          setPegarAlternados(event.target.checked)
                        }
                      />
                    }
                    label="Mostrar alternados"
                  />
                </Col>

                <Col sm="3">
                  <FormControlLabel
                    className="ml-1"
                    style={{
                      alignItems: 'center',
                      marginBottom: 0,
                    }}
                    control={
                      <Checkbox
                        className="p-0"
                        color="primary"
                        size="small"
                        checked={mostrarInativas}
                        onChange={event => {
                          const { checked } = event.target;
                          setMostrarInativas(checked);
                          if (
                            codigoOportunidade ||
                            configuracaoIdPesquisar ||
                            pessoaSelecionada?.codigoDomsge ||
                            propostaIdFiltrada ||
                            orcamentos.length > 0
                          ) {
                            handleBuscaOportunidades(undefined, checked);
                          }
                        }}
                      />
                    }
                    label={
                      <span style={{ whiteSpace: 'nowrap' }}>
                        Mostrar Inativas
                      </span>
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col sm="12">
                  <div className="mt-2">
                    <PessoaContainer>
                      <Row>{detalhesPessoa?.razaoSocial}</Row>
                    </PessoaContainer>
                    <PessoaContainer>
                      <Row>
                        <Municipio>
                          {detalhesPessoa?.municipioDescricao}{' '}
                        </Municipio>
                        {detalhesPessoa?.ufSigla
                          ? `/${detalhesPessoa?.ufSigla}`
                          : ''}
                      </Row>
                    </PessoaContainer>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col sm="4">
                    <h4>{orcamentos.length} configurações</h4>
                  </Col>
                  <Col sm="3">
                    <BotoesProposta
                      rows={configuracoesMarcadas}
                      onClick={() => setModalInclusaoEmProposta(true)}
                      onClickNovaProposta={handleAskNovaProposta}
                    />
                  </Col>
                  <Col sm="2">
                    {habilitarBotaoNovo && (
                      <Button
                        size="sm"
                        className="btn-outline-default p-2 float-right"
                        color="primary"
                        type="button"
                        onClick={handleNavigateNovoOrcamento}
                      >
                        Nova configuração <FaPlusCircle />
                      </Button>
                    )}
                  </Col>
                  <Col sm="3">
                    <CampoBuscaFiltrarLista
                      lista={orcamentos}
                      setState={setResultadoFiltrado}
                      camposBuscar={[
                        o => o.pivoCentral,
                        o => o.nome,
                        o => o.razaoSocial,
                        o => o.proposta_id,
                        o => o.nome_prod,
                        o => o.createdAt,
                      ]}
                      largura={70}
                      exibirCampo={exibeCampoBusca}
                    />
                  </Col>
                </Row>
              </CardHeader>

              <>{listaConfiguracoes}</>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ConfiguracaoListaGNF;
